import { render, staticRenderFns } from "./AssociatedProducts.vue?vue&type=template&id=288aa3cb"
import script from "./AssociatedProducts.vue?vue&type=script&lang=ts"
export * from "./AssociatedProducts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports